module.exports = __webpack_public_path__ + "img/5YW_logo.5597f2a2.png";